import { render, staticRenderFns } from "./HistoryOfChangesTableItem.vue?vue&type=template&id=4688585e"
import script from "./HistoryOfChangesTableItem.vue?vue&type=script&lang=js"
export * from "./HistoryOfChangesTableItem.vue?vue&type=script&lang=js"
import style0 from "./HistoryOfChangesTableItem.vue?vue&type=style&index=0&id=4688585e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports